export const DEFAULT_TIMEZONE = 'Eastern Time (US & Canada)'